import * as PIXI from "pixi.js"
import EventApi from "../../../../../api/EventsApi";
// @ts-ignore
import store from "../../../../../store";

export default class PixiVideoContainer extends PIXI.Container {
    private itemsLength = 1;

    constructor() {
        super();
        this.name = 'videoContainer';

        this.initEvents();
        this.init();
    }

    private initEvents(): void
    {
        EventApi.addEventListener(EventApi.REMOTE_MEDIA_ADDED, this.addRemoteSeat.bind(this));
        EventApi.addEventListener(EventApi.LOCAL_TRACK_PUBLISHED, this.addLocalSeat.bind(this));
    }

    private unbindEvents(): void
    {
        EventApi.removeEventListener(EventApi.REMOTE_MEDIA_ADDED, this.addRemoteSeat.bind(this));
        EventApi.removeEventListener(EventApi.LOCAL_TRACK_PUBLISHED, this.addLocalSeat.bind(this));
    }

    /**
     * Удалить видео, отвязать слушатели событий
     */
    public clearAll(): void
    {
        this.removeChild(...this.children);
        this.itemsLength = 0;
        this.destroy(true);
        this.unbindEvents();
    }

    public init(): void
    {
        setTimeout(() => {
            const videos = document.querySelectorAll("#seatsHolder video");
            if (!videos.length) {
                return;
            }
            videos.forEach((video , index) => {
                this.createVideoSeat(video as HTMLVideoElement, index, video.id);
            });
        }, 1000);
    }

    /**
     * Удалить видео по id
     * @param id
     * @private
     */
    private deleteVideoById(id: string): void
    {
        const itemsForDelete = this.children.filter(child => child.name === id);
        this.removeChild(...itemsForDelete);
        if (this.itemsLength) {
            this.itemsLength--;
        }
    }

    /**
     * Создать сит на столе
     * @param video
     * @param index
     * @param id
     * @private
     */
    private createVideoSeat(video: HTMLVideoElement, index: number, id: string): void
    {
        this.deleteVideoById(id);
        let videoSprite: PIXI.Sprite | null = null;
        try {
            videoSprite = new PIXI.Sprite(PIXI.Texture.from(video));
            videoSprite.name = id;
        }
        catch (e) {
            console.log('%c ### >>>', 'color: #f0f', e.message);
        }
        if (!videoSprite) {
            console.log('%c ### !videoSprite', 'color: #f0f');
            return;
        }

        const width = videoSprite.width, height = videoSprite.height, minSize = Math.min(width, height);
        // console.log('%c ### SIZE:', 'color: #f0f', width, height, 100 / minSize);
        videoSprite.scale.set(150 / minSize);
        videoSprite.position.set((index % 3) * (videoSprite.width  + 8), 100);
        this.addChild(videoSprite);
        // console.log('%c ### POS:', 'color: #f0f', videoSprite.position, videoSprite.parent?.name);

        const videoCont = new PIXI.Container;
        videoCont.name = id;
        this.addChild(videoCont);
        videoCont.position.set(videoSprite.x, videoSprite.y);

        const videoMask = new PIXI.Graphics().beginFill(0xffffff)
            .drawCircle(width/2, height/2, minSize/2).endFill();
        videoSprite.addChild(videoMask);
        videoSprite.mask = videoMask;

        videoSprite.interactive = true;
        videoSprite.on('pointerdown', () => { videoSprite && (videoSprite.buttonMode = true) });
        videoSprite.on('pointerup', () => { videoSprite && (videoSprite.buttonMode = false) });
        videoSprite.on('pointerupoutside', () => { videoSprite && (videoSprite.buttonMode = false) });
        videoSprite.on('pointermove', e => {
            if (videoSprite && videoSprite.buttonMode) {
                const { movementX, movementY } = e.data.originalEvent;
                videoSprite.position.set(videoSprite.x + movementX, videoSprite.y + movementY);
                videoCont.position.set(videoSprite.x, videoSprite.y);
            }
        });

        this.itemsLength ++;

        if (!index) {
            const btnCam = this.addVideoBtn(8, 8, () => {
                btnCam.tint = store.getters.getCameraStatus ? 0x9e9e9e : 0xf44336;
                EventApi.triggerEvent(EventApi.TABLE_CAMERA);
            });
            videoCont.addChild(btnCam);
            btnCam.tint = store.getters.getCameraStatus ? 0xf44336 : 0x9e9e9e;

            const btnMic = this.addVideoBtn(32, 8, () => {
                btnMic.tint = store.getters.getMicrophoneStatus ? 0x9e9e9e : 0x4caf50;
                EventApi.triggerEvent(EventApi.TABLE_MICROPHONE);
            });
            videoCont.addChild(btnMic);
            btnMic.tint = store.getters.getMicrophoneStatus ? 0x4caf50 : 0x9e9e9e;

            const btnExit = this.addVideoBtn(56, 8, () => {
                btnExit.tint = 0xffbf00;
                EventApi.triggerEvent(EventApi.EXIT_SEAT);
                this.deleteVideoById(id);
            });
            videoCont.addChild(btnExit);
        }
    }

    /**
     * Добавить локальный сит
     * @private
     */
    private addLocalSeat(): void
    {
        setTimeout(() => {
            const video = document.querySelector("#seatsHolder #localSeat video") as HTMLVideoElement|null;
            if (!video) {
                return;
            }
            this.createVideoSeat(video, 0, video.id);

        }, 1000);
    }

    /**
     * Добавление удаленного сита на стол
     */
    private addRemoteSeat(e: any): void
    {
        const id = e.detail;
        setTimeout(() => {
            const video = document.querySelector(`#seatsHolder:not(#localSeat) video[id*="${id}"]`);
            this.createVideoSeat(video as HTMLVideoElement, this.itemsLength, id);
        }, 1000);
    }

    private addVideoBtn(x: number, y: number, cb: ()=>void): PIXI.Sprite
    {
        const btn = new PIXI.Sprite(PIXI.Texture.WHITE);
        btn.position.set(x, y);
        btn.interactive = true;
        btn.buttonMode  = true;
        btn.on('pointerup', e => {
            e.data.originalEvent.stopPropagation();
            cb();
        });
        return btn;
    }
}
